"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var lodash_1 = __importDefault(require("lodash"));
var currency_js_1 = __importDefault(require("currency.js"));
var toastNotification_1 = __importDefault(require("@/Modules/Misc/toastNotification"));
var PlaceBidDialog = /** @class */ (function (_super) {
    __extends(PlaceBidDialog, _super);
    function PlaceBidDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PlaceBidDialog.prototype, "disableSubmit", {
        get: function () {
            return !this.acceptPostWarningBid &&
                this.showWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlaceBidDialog.prototype, "parsedAmount", {
        get: function () {
            return (0, currency_js_1.default)(this.amount).value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlaceBidDialog.prototype, "bidExceedsFloorBy", {
        get: function () {
            return lodash_1.default.round(this.parsedAmount - this.bidFloor, 2);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlaceBidDialog.prototype, "showWarning", {
        get: function () {
            return this.bidExceedsFloorBy >= 500;
        },
        enumerable: false,
        configurable: true
    });
    PlaceBidDialog.prototype.dialogPropertyChange = function (newValue) {
        var _this = this;
        if (newValue) {
            this.$nextTick(function () {
                setTimeout(function () { var _a, _b; return (_b = (_a = _this.$refs.submitBtn) === null || _a === void 0 ? void 0 : _a.$el) === null || _b === void 0 ? void 0 : _b.focus(); });
            });
        }
    };
    PlaceBidDialog.prototype.closeDialog = function () {
        this.$emit('input', false);
    };
    PlaceBidDialog.prototype.currency = function (arg) {
        return (0, currency_js_1.default)(arg);
    };
    PlaceBidDialog.prototype.handleSubmit = function () {
        var _this = this;
        this.form.transform(function (data) { return (__assign(__assign({}, data), { amount: _this.parsedAmount })); }).post((0, route_1.default)("item.bid.store", {
            item: this.hashId,
        }), {
            preserveState: false,
            onSuccess: function (response) {
                var flash = response.props.flash;
                (0, toastNotification_1.default)(_this.$toast, flash.message, flash.messageColor);
            },
            onError: function (error) {
                console.error(error);
            }
        });
        this.closeDialog();
        this.$emit('submit');
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: [Number, String], required: false })
    ], PlaceBidDialog.prototype, "amount", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Boolean, required: true })
    ], PlaceBidDialog.prototype, "acceptPostWarningBid", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Boolean, required: true })
    ], PlaceBidDialog.prototype, "value", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            type: Object,
            required: true
        })
    ], PlaceBidDialog.prototype, "form", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            type: String,
            required: true
        })
    ], PlaceBidDialog.prototype, "hashId", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            type: Number,
            required: true
        })
    ], PlaceBidDialog.prototype, "bidFloor", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ required: true, type: Boolean })
    ], PlaceBidDialog.prototype, "currentUserIsHighestBidder", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)("value")
    ], PlaceBidDialog.prototype, "dialogPropertyChange", null);
    PlaceBidDialog = __decorate([
        vue_property_decorator_1.Component
    ], PlaceBidDialog);
    return PlaceBidDialog;
}(vue_property_decorator_1.Vue));
exports.default = PlaceBidDialog;
